import { Component, inject } from '@angular/core';
import { UI_KENDO } from '@maximizer/core/shared/ui/kendo';
import { OnboardingService } from '@maximizer/outlook/shared/data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOG } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'maximizer-outlook-onboarding-exit',
  template: `
    <kendo-dialog [width]="256">
      <div class="py-2 flex flex-col gap-2">
        <p class="text-body bold">
          {{ 'outlook.onboarding.exit.title' | translate }}
        </p>
        <p class="text-body">
          {{ 'outlook.onboarding.exit.message' | translate }}
        </p>
        <p class="text-body">
          {{ 'outlook.onboarding.exit.confirm' | translate }}
        </p>
        <div class="flex justify-end gap-2 pt-2">
          <button
            kendoButton
            id="outlook-onboarding-ui-exit-cancel"
            themeColor="primary"
            fillMode="flat"
            class="uppercase"
            (click)="onboardingService.showExitDialog.set(false)"
          >
            {{ 'outlook.buttons.cancel' | translate }}
          </button>
          <button
            kendoButton
            id="outlook-onboarding-ui-exit-exit"
            themeColor="primary"
            class="uppercase"
            (click)="onboardingService.quit()"
          >
            {{ 'outlook.buttons.exit' | translate }}
          </button>
        </div>
      </div>
    </kendo-dialog>
  `,
  imports: [KENDO_BUTTON, KENDO_DIALOG, TranslatePipe, UI_KENDO],
})
export class ExitComponent {
  onboardingService = inject(OnboardingService);
}
